const _ = require('lodash');

const SavedListsService = function SavedListsService(restangular, $q, bootstrap, analyticsService) {
    this._edrProductsRoute = restangular.one('edr');
    this._savedListsRoute = restangular.one('mylists');
    this.restangular = restangular;
    this.analyticsService = analyticsService;
    this.eventsDtm = analyticsService.eventsDtm;
    this.savedLists = undefined;
    this.currentSavedList = '';
    this.myListsMode = '';
    this.listName = '';
    this.listId = undefined;
    this._isServiceAvailable = true;

    this.defaultListId = undefined;
    this.result = { Success: false, Message: '' };
    this.selectedList = null;
    this.selectedListProductsCount = 0;
    this.myEDRselected = false;
    this.isListEmpty = undefined;
    this._savedListsPromise = null;

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SavedLists)) {
        // we do this instead of invalidating on login because sometimes the saved lists service hasn't been
        // instantiated before the login event, meaning we can't call invalidate and the incorrect bootstrapped data
        // will be loaded.
        const bootstrappedSavedLists = bootstrap.getBootstrappedData(bootstrap.bootstrapped.SavedLists);

        if (bootstrappedSavedLists.Response.length > 0) {
            this._savedListsPromise = $q.when(this._setSavedLists(bootstrappedSavedLists));
        }
    }
};

SavedListsService.prototype._setSavedLists = function (data) {
    this._isServiceAvailable = data.IsServiceAvailable;
    this.savedLists = data.Response;
    return this.savedLists;
};

SavedListsService.prototype.isServiceAvailable = function () {
    return this._isServiceAvailable;
};

SavedListsService.prototype.listSavedLists = function () {
    if (this._savedListsPromise) {
        return this._savedListsPromise;
    }

    this._savedListsPromise = this._savedListsRoute.get().then(this._setSavedLists.bind(this));

    return this._savedListsPromise;
};

SavedListsService.prototype.selectList = function (listProductsService, freeTextTagsService, listId) {
    this.selectedList = _.find(this.savedLists, { ListId: parseInt(listId) });
    this.isListEmpty = this.selectedList ? this.selectedList.ProductsCount <= 0 : true;
    this.listId = listId;
    this.selectedListProductsCount = this.selectedList ? this.selectedList.ProductsCount : 0;
    this.myEDRselected = false;
    listProductsService.suggestedListClickedPreviously = false;
    freeTextTagsService.getTagsFor(listId);
};

SavedListsService.prototype.selectEDRList = function (listProductsService) {
    this.listId = 'MyWoolworthsRewards';
    this.selectedList = null;
    this.selectedListProductsCount = 0;
    this.myEDRselected = true;
    listProductsService.suggestedListClickedPreviously = false;
    this.isListEmpty = false;
};

function createArgs(args) {
    return {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType,
    };
}

SavedListsService.prototype.getProductsForSelectedList = function (args, listId = this.listId) {
    const promise = (listId === 'MyWoolworthsRewards')
        ? this._edrProductsRoute.doGET('Products', createArgs(args)).then((response) => {
            this.isListEmpty = false;
            return response;
        })
        : this.restangular.one('mylists', listId).doGET('products', createArgs(args)).then((response) => {
            if (args.PageNumber === 1) {
                this.isListEmpty = (response.Items.length === 0);
            }
            return response;
        });
    return promise.then(response => ({
        items: response.Items,
        totalRecordCount: response.TotalRecordCount,
    }));
};

SavedListsService.prototype.checkIfDefaultListEmpty = function () {
    return this.getProductsForSelectedList({ pageNumber: 1, pageSize: 1, sortType: 'Name' })
        .then(response => !(response && response.Items.length > 0));
};

SavedListsService.prototype.updateList = function (id, name) {
    return this._savedListsRoute.one('edit').doPOST({ Id: id, Name: name }).then((result) => {
        if (result.Success) {
            this.invalidate();
        }

        return result;
    });
};

SavedListsService.prototype.setDefaultList = function (listId) {
    return this._savedListsRoute.one('setdefaultlist', listId).doPOST().then(this.invalidate.bind(this));
};

SavedListsService.prototype.deleteList = function (listId) {
    return this._savedListsRoute.one('deleteList', listId).doPOST().then(this.invalidate.bind(this));
};

SavedListsService.prototype.clearList = function (listId) {
    return this._savedListsRoute.one('clearlist', listId).doPOST();
};

SavedListsService.prototype.deleteListItem = function (id, stockcode) {
    this.selectedListProductsCount--;

    return this._savedListsRoute.one('deleteitem').doPOST({ Id: id, StockCode: stockcode }).then(() => {
        this.refresh();
    });
};

SavedListsService.prototype.addToList = function (listId, stockcode, quantity) {
    this.analyticsService.pushEvent(this.eventsDtm.SAVE_TO_LIST);
    return this.restangular.one('mylists', listId).one('Items').doPOST({ StockCode: stockcode, Quantity: quantity });
};

SavedListsService.prototype.setHideCheckedFreeTextTags = function (hideChecked) {
    return this._savedListsRoute.one('sethidecheckedfreetext').doPOST({ Id: this.listId, HideChecked: hideChecked });
};

SavedListsService.prototype.isHideCheckedFreeTextTags = function () {
    return this._savedListsRoute.one('gethidecheckedfreetext').get({ Id: this.listId });
};

SavedListsService.prototype.saveNewList = function (name) {
    return this._savedListsRoute.one('add').doPOST({ Name: name }).then(this.invalidate.bind(this));
};

SavedListsService.prototype.getList = function (listId) {
    return this._savedListsRoute.one(listId).get();
};

SavedListsService.prototype.getCurrentListId = function () {
    return this.listId;
};

SavedListsService.prototype.getDefaultListId = function () {
    return this._savedListsRoute.one('DefaultListId').get();
};

SavedListsService.prototype.invalidate = function (arg) {
    this._savedListsPromise = null;
    this.savedLists = [];

    return arg;
};

SavedListsService.prototype.refresh = function (arg) {
    this.invalidate(arg);
    return this.listSavedLists();
};

module.exports = SavedListsService;



// WEBPACK FOOTER //
// ./src/common/savedlists/saved-lists.service.js